/**
 * In-screen pill tab switcher — the house style (#eef3f5 track, #e3e9ec border,
 * white active pill) shared with AdminLayout's sub-nav so an admin screen's
 * internal views read as the same control family as the section tabs above them.
 */
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

export const PILL_TRACK_SX = {
  display: "inline-flex",
  gap: "4px",
  p: "3px",
  borderRadius: "10px",
  background: "#eef3f5",
  border: "1px solid #e3e9ec",
};

export const pillSx = (active) => ({
  px: 1.5,
  py: 0.6,
  borderRadius: "8px",
  fontSize: 12.5,
  fontWeight: active ? 700 : 500,
  color: active ? "#0f172a" : "#64748b",
  background: active ? "#fff" : "transparent",
  boxShadow: active ? "0 1px 2px rgba(15,23,42,0.08)" : "none",
  cursor: "pointer",
  whiteSpace: "nowrap",
  userSelect: "none",
});

export const PillSwitcher = ({ items, value, onChange }) => (
  <Box sx={PILL_TRACK_SX}>
    {items.map((item) => (
      <Box
        key={item.key}
        onClick={() => onChange(item.key)}
        sx={pillSx(value === item.key)}
      >
        {item.label}
      </Box>
    ))}
  </Box>
);

PillSwitcher.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.node }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default PillSwitcher;
